import { useTranslation } from 'react-i18next';

interface SummaryMetadataProps {
  start?: string | null;
  end?: string | null;
  location?: string | null;
}

/**
 * Formats a UTC date string to local time display.
 * Ensures the date string has a 'Z' suffix for proper UTC parsing.
 */
const formatDateToLocal = (dateString: string, locale: string): string => {
  const utcDate = dateString.endsWith('Z') ? dateString : dateString + 'Z';
  return new Date(utcDate).toLocaleString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

/**
 * Displays meeting metadata (start time, end time, location) from summary.
 */
export const SummaryMetadata = ({ start, end, location }: SummaryMetadataProps) => {
  const { t, i18n } = useTranslation();

  if (!start && !end && !location) {
    return null;
  }

  return (
    <div className="text-sm text-gray-700">
      {start && (
        <div>
          <span className="font-medium">{t('meeting-secretary.meetings.start')}:</span>{' '}
          {formatDateToLocal(start, i18n.language)}
        </div>
      )}
      {end && (
        <div>
          <span className="font-medium">{t('meeting-secretary.meetings.end')}:</span>{' '}
          {formatDateToLocal(end, i18n.language)}
        </div>
      )}
      {location && (
        <div>
          <span className="font-medium">{t('meeting-secretary.meetings.location')}:</span>{' '}
          {location}
        </div>
      )}
    </div>
  );
};
